"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAndCheckIfPlayersChanged = fetchAndCheckIfPlayersChanged;
exports.processPlayersSaga = processPlayersSaga;
const effects_1 = require("redux-saga/effects");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const utils_1 = require("../../../domain/players/utils");
const selectors_1 = require("../../PlayersProvider/selectors");
const slice_1 = require("../../PlayersProvider/slice");
const players_1 = require("../../../utils/players");
function* fetchAndCheckIfPlayersChanged(prevEvent, newEvent) {
    const prevEventPlayersIds = (0, utils_1.getPlayerIdsForEvent)(prevEvent);
    const prevPlayers = yield (0, effects_1.select)(selectors_1.selectPlayersListByIds, prevEventPlayersIds);
    const newEventPlayerIds = (0, utils_1.getPlayerIdsForEvent)(newEvent);
    yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayers({ playersIds: newEventPlayerIds }));
    const { fetchPlayersSuccess } = yield (0, effects_1.race)({
        fetchPlayersSuccess: (0, effects_1.take)(slice_1.playersProviderActions.fetchPlayersSuccess),
        fetchPlayersFailed: (0, effects_1.take)(slice_1.playersProviderActions.fetchPlayersError),
        fetchPlayersStopped: (0, effects_1.take)(slice_1.playersProviderActions.fetchPlayersStopped),
    });
    const newPlayers = yield (0, effects_1.select)(selectors_1.selectPlayersListByIds, newEventPlayerIds);
    const playersChanged = fetchPlayersSuccess && !(0, react_fast_compare_1.default)(prevPlayers, newPlayers);
    return playersChanged;
}
// fetching player names to show in table by ids from probabilities
function* processPlayersSaga({ probabilities }) {
    const uniquePlayersIds = (0, players_1.getUniquePlayerIds)(probabilities, players_1.getParametersFromEvent);
    yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayers({ playersIds: uniquePlayersIds }));
}
//# sourceMappingURL=fetchPlayersSaga.js.map